import React from 'react'
function Invoices() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_templates">
               <h1>Invoices</h1>
               <hr/>
               <p>Invoices are another important feature of the Safexpay payment gateway system that allows merchants to create and send invoices to customers for payment. </p>
               <h5>
                  Key Features:
               </h5>
               <ul>
                  <li>
                     <b>Easy to create:</b> Invoices can be created easily through the Safexpay dashboard, without the need for technical expertise or integration with a website or app.
                  </li>
                  <li>
                     <b>Customizable:</b> Invoices can be customized with the merchant's branding, including the logo, color scheme, and other design elements, to provide a professional and branded payment experience for customers.
                  </li>
                  <li>
                     <b>Multiple payment options:</b> Invoices support multiple payment options, including credit cards, debit cards, net banking, and UPI, providing flexibility and convenience for customers.
                  </li>
                  <li>
                     <b>Automated payment reminders:</b> Invoices can be set up to send automated payment reminders to customers, reducing the need for manual follow-up and improving the likelihood of timely payments.
                  </li>
                  <li>
                     <b>Secure:</b> Invoices are secure and use industry-standard encryption to protect customer data and prevent fraud, ensuring a secure payment experience for customers.
                  </li>
                  <li>
                     <b>Detailed reporting:</b> Invoices offer detailed reporting and analytics, enabling merchants to track and manage payment activity and gain insights into customer behaviour.
                  </li>
               </ul>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default Invoices